// BLOCKY_KONTROLA_V1 (23. 10. 2026, session MKSOFT) — Faktúry › Na zaúčtovanie podľa schváleného mockupu MOCKUP_Blocky_kontrola_2026-10-23.html
// (Mirko „myslim ze toto je OK“, Kronika mksoft 3041; zadanie 3036: „pred exportom bločky … skontrolovať aspon prvy mesiac ak tabulka bude správne
// rozopočítana tak potom export“). FÁZA 1: Matrix bločky rozpočíta po položkách (GET /api/uctovny-export/kontrola), back office ich porovná so svojím
// zaúčtovaním v MKsofte a označí Sedí / Nesedí — opraviť (účet riadku + poznámka, oprava sa zapamätá, ústava 15.4). Export do MKsoftu je vypnutý
// (ústava 86.13, 15.1). Predtým tu bol zoznam s detailom a export .xls (86.1–86.12); PIN zámok, roly a rozpočet po položkách ostávajú.
// Ručné pridanie bločku je o úroveň vyššie (Došlé faktúry a bločky › Bločky › + Nový bloček) — lišta nad prácou ostáva v jednom rade ako v mockupe
// (Mirko 20. 10.), farby z témy (61.10).
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import { useDirtyFlag } from '../hooks/useDirtyState.js'
import { COLORS, TYPO, SPACE, RADIUS, TINT } from '../theme.js'
import { EmptyPane, SearchableSelect } from '../components/Ui.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from '../components/Toast.jsx'
import { useAuth } from '../auth/AuthContext.jsx'
import { usePinGate } from '../hooks/usePinGate.jsx'
import { BtnAdd, BtnGhost } from '../components/Btn.jsx'
import HelpHint from '../components/HelpHint.jsx'
import { strazKlik } from '../hooks/unsavedGuard.js'   // BLOCKY_MOCKUP_V4 č. 24: rozpísané Nesedí sa nezahodí bez otázky
// BLOCKY_SPRACUJE_V1 (ústava 135.2, Mirko 23. 10. 2026): Sedí / Nesedí len back office a admin — server posiela data.spracuje

const ALLOWED = ['admin', 'owner', 'office_manager', 'accountant']   // 86.1 — server to isté drží v stráži rolí aj v module
const FILTRE = [
  { key: 'vsetky', label: 'Všetky' }, { key: 'na_kontrolu', label: 'Na kontrolu' }, { key: 'sedi', label: 'Sedí' }, { key: 'nesedi', label: 'Nesedí' },
  { key: 'banka', label: 'Nespárované s bankou', nove: true },   // BLOCKY_MOCKUP_V2: kartové bločky bez potvrdeného riadku výpisu VÚB
]
const nesparovanyBanka = (r) => !!(r.banka && r.banka.stav !== 'sparovane')
const NAPOVEDA = 'Ako to funguje. Konateľ naskenuje QR z bločku v telefóne, Matrix stiahne bloček z eKasy (predajca, položky, sadzba DPH) a každú položku rozpočíta na vlastnom riadku.\n\nÚčtovné veci sú z MKsoftu (ústava 110.14): kategória položky určuje kód predkontácie MKsoftu (podľa platby karta / hotovosť), z neho účet MD, protiúčet D a typ dokladu P/I. Pomer nákladu a DPH (napr. nafta 80 % / DPH 50 %) a nedaňové účty (501NNAK, 501NDPH) sa čítajú z predkontácie a rozvrhu účtov MKsoftu — v Matrixe sa nemenia. Zmeniť sa dá kategória položky (káva na bločku z pumpy → Reštaurácie), účet sa potom vezme z jej predkontácie. Účty na výber sú z osnovy MKsoftu.\n\nBanka: párovanie s výpisom VÚB robí Štefánia v časti Bločky; tu sa výpis len zobrazuje. Hotovosť ukáže výdaje v Pokladni (len na pozretie, Pokladňu zapisuje office).\n\nPorovnanie s MKsoftom: v MKsoft KAMIR (len čítanie) Matrix sám nájde doklad Štefánie s rovnakou sumou. Sedí / Nesedí klikajú len Štefánia a Mirko (ústava 135.2).\n\nNáhľad dokladu ukazuje, čo pôjde do MKsoft KAMIR; posiela sa z časti Bločky (od 1. 11. 2026, po spárovaní a Sedí).'

const eur = (n) => (Number(n) || 0).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const eurS = (n) => eur(n) + ' €'
const datumSk = (d) => { const m = String(d || '').match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? `${+m[3]}. ${+m[2]}.` : (d || '') }

const malo = { fontSize: TYPO.sizes.sm, color: COLORS.muted, marginTop: 2, lineHeight: 1.35 }
const tagBase = { display: 'inline-block', fontSize: TYPO.sizes.sm, borderRadius: RADIUS.md, padding: '2px 7px', whiteSpace: 'nowrap', fontWeight: TYPO.weights.medium }
const TAG = {
  na_kontrolu: { ...tagBase, background: COLORS.totalBg, color: COLORS.warn },
  sedi: { ...tagBase, background: COLORS.addBg, color: COLORS.add },
  nesedi: { ...tagBase, background: COLORS.removeBg, color: COLORS.remove },
  modra: { ...tagBase, background: COLORS.navBg, color: COLORS.nav },
}
const STAV_TEXT = { na_kontrolu: 'Na kontrolu', sedi: 'Sedí', nesedi: 'Nesedí' }
const chyba = { color: COLORS.remove, fontWeight: TYPO.weights.semibold }

function Chip({ on, onClick, children }) {
  return (
    <button type="button" onClick={onClick} style={{ border: `1px solid ${on ? COLORS.nav : COLORS.line}`, background: on ? COLORS.nav : COLORS.bg, color: on ? '#fff' : COLORS.text, borderRadius: RADIUS.full, padding: '5px 11px', fontFamily: 'inherit', fontSize: TYPO.sizes.base, cursor: 'pointer', whiteSpace: 'nowrap' }}>{children}</button>
  )
}

export default function UctovanieExportPane() {
  const toast = useToast()
  const { user } = useAuth()
  const gate = usePinGate()
  const authorized = ALLOWED.includes(user?.role)

  const [unlocked, setUnlocked] = useState(false)
  const [data, setData] = useState(null)
  const [filter, setFilter] = useState('vsetky')
  const [ucty, setUcty] = useState([])
  const [kategorie, setKategorie] = useState([])   // predkontácie Matrixu — kategória položky v Nesedí — opraviť
  const [edit, setEdit] = useState(null)       // { id, pozn, opravy: { riadok: ucet } } — rozpísaná oprava (Nesedí)
  const [busy, setBusy] = useState(false)
  const [vypis, setVypis] = useState({ mesiac: '', rows: [] })   // BLOCKY_MOCKUP_V2: výpis VÚB (platby z účtu) mesiaca na „Iný riadok výpisu“
  useDirtyFlag(!!edit && (edit.pozn.trim() !== '' || Object.keys(edit.opravy).length > 0), { key: 'blocky-kontrola', discard: () => setEdit(null) })   // straz_v4 (53.1.b)

  const load = useCallback((mesiac) => {
    fetchAuth('/api/uctovny-export/kontrola' + (mesiac ? '?mesiac=' + encodeURIComponent(mesiac) : ''))
      .then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.error || 'HTTP ' + r.status); setData(d) })
      .catch(e => toast.error('Bločky: ' + e.message))
  }, [toast])

  useEffect(() => {
    if (!authorized) return
    let alive = true
    gate('uctovny_export', { modul: 'Na zaúčtovanie', pristup: user?.role }).then(res => {
      if (!alive || !res || !res.ok) return
      setUnlocked(true); load('')
      fetchAuth('/api/uctovny-export/ucty').then(r => r.ok ? r.json() : {}).then(d => { if (alive) setUcty(Array.isArray(d && d.ucty) ? d.ucty : []) }).catch(() => {})   // BLOCKY_MOCKUP_V1: rozvrh účtov MKsoftu
      fetchAuth('/api/predkontacie').then(r => r.ok ? r.json() : []).then(d => { if (alive) setKategorie((Array.isArray(d) ? d : []).filter(p => p.active !== 0).map(p => p.kategoria).sort((a, b) => a.localeCompare(b, 'sk'))) }).catch(() => {})
    })
    return () => { alive = false }
  }, [authorized])   // eslint-disable-line

  const rows = useMemo(() => (data && data.rows) || [], [data])
  const pocty = (data && data.pocty) || { vsetky: 0, suma: 0, na_kontrolu: 0, sedi: 0, nesedi: 0, skontrolovane: 0 }
  const filtered = useMemo(() => filter === 'vsetky' ? rows : filter === 'banka' ? rows.filter(nesparovanyBanka) : rows.filter(r => r.stav === filter), [rows, filter])
  const pocetBanka = useMemo(() => rows.filter(nesparovanyBanka).length, [rows])
  // BLOCKY_MOCKUP_V3: kým server nemá rozvrh a predkontácie MKsoftu, nič sa nepočíta — skúsi znova každých 15 s
  useEffect(() => {
    if (!data || !data.caka_mksoft) return
    const t = setTimeout(() => load(data.mesiac), 15000)
    return () => clearTimeout(t)
  }, [data])   // eslint-disable-line
  useEffect(() => {
    if (!data || !data.mesiac || vypis.mesiac === data.mesiac || !rows.some(x => x.banka)) return
    const m = data.mesiac
    fetchAuth('/api/uctovny-export/kontrola-vypis?mesiac=' + encodeURIComponent(m)).then(r => r.ok ? r.json() : { rows: [] })
      .then(d => setVypis({ mesiac: m, rows: Array.isArray(d && d.rows) ? d.rows : [] })).catch(() => {})
  }, [data && data.mesiac, rows])   // eslint-disable-line
  const ucetOptions = useMemo(() => ucty.map(u => ({ value: u.ucet, label: u.nazov ? `${u.ucet} · ${u.nazov}` : u.ucet })), [ucty])
  const katOptions = useMemo(() => kategorie.map(k => ({ value: k, label: k })), [kategorie])

  const apply = (row) => setData(d => {
    if (!d) return d
    const rs = d.rows.map(x => x.id === row.id ? row : x)
    const n = (s) => rs.filter(r => r.stav === s).length
    const p = { ...d.pocty, na_kontrolu: n('na_kontrolu'), sedi: n('sedi'), nesedi: n('nesedi') }
    p.skontrolovane = p.sedi + p.nesedi
    return { ...d, rows: rs, pocty: p }
  })
  const zapis = async (id, body) => {
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/uctovny-export/kontrola/${encodeURIComponent(id)}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(d.error || 'HTTP ' + r.status)
      apply(d.row); return true
    } catch (e) { toast.error(e.message); return false } finally { setBusy(false) }
  }
  const zmenKategoriu = async (r, polozka, kategoria) => {
    setBusy(true)
    try {
      const res = await fetchAuth(`/api/uctovny-export/kontrola/${encodeURIComponent(r.id)}/polozka`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ item_id: polozka.id, kategoria }) })
      const d = await res.json().catch(() => ({}))
      if (!res.ok) throw new Error(d.error || 'HTTP ' + res.status)
      apply(d.row); setEdit(e => (e && e.id === r.id ? { ...e, opravy: Object.fromEntries(Object.entries(e.opravy).filter(([k]) => !k.startsWith('i' + polozka.id + '#'))) } : e))   // BLOCKY_MOCKUP_V2: nová kategória = účet z jej predkontácie
      toast.success('Položka „' + polozka.nazov + '“ → ' + (kategoria || 'ako bloček'))
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  const potvrdKategorie = async (r) => {   // BLOCKY_MOCKUP_V5: navrhnuté kategórie položiek → potvrdené (a zapamätané pre predajcu)
    setBusy(true)
    try {
      const res = await fetchAuth(`/api/uctovny-export/kontrola/${encodeURIComponent(r.id)}/kategorie`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      const d = await res.json().catch(() => ({}))
      if (!res.ok) throw new Error(d.error || 'HTTP ' + res.status)
      apply(d.row); toast.success('Kategórie položiek potvrdené')
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  const banka = async (r, body) => {   // BLOCKY_MOCKUP_V2: Potvrdiť párovanie / Iný riadok výpisu / Zrušiť párovanie
    setBusy(true)
    try {
      const res = await fetchAuth(`/api/uctovny-export/kontrola/${encodeURIComponent(r.id)}/banka`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      const d = await res.json().catch(() => ({}))
      if (!res.ok) throw new Error(d.error || 'HTTP ' + res.status)
      apply(d.row); setVypis(v => ({ ...v, mesiac: '' }))   // výpis sa načíta znova (riadok sa obsadil / uvoľnil)
      toast.success(body.zrusit ? 'Párovanie s výpisom zrušené' : 'Bloček spárovaný s výpisom VÚB')
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  // BLOCKY_POROVNANIE_V1 (časť 4): načíta Števkine doklady P a I z MKsoftu (KAMIR, len čítanie) a porovná ich s bločkami mesiaca
  const [mkBusy, setMkBusy] = useState(false)
  // BLOCKY_MOCKUP_V1: ako v mockupe — „V MKsofte“ sa dopĺňa samo pri otvorení mesiaca (raz za 30 min), bez tlačidla
  const mkSpustene = useRef({})
  useEffect(() => {
    if (!data || !data.rows || !data.rows.length || mkBusy) return
    const m = data.mesiac
    const stare = !data.mksoft_nacitane || (Date.now() - new Date(String(data.mksoft_nacitane).replace(' ', 'T') + 'Z').getTime()) > 30 * 60 * 1000
    if (!stare || mkSpustene.current[m]) return
    mkSpustene.current[m] = true
    setMkBusy(true)
    fetchAuth('/api/uctovny-export/kontrola-mksoft?mesiac=' + encodeURIComponent(m))
      .then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.error || 'HTTP ' + r.status); load(m) })
      .catch(e => toast.error('Porovnanie s MKsoftom: ' + e.message))
      .finally(() => setMkBusy(false))
  }, [data && data.mesiac, data && data.mksoft_nacitane])   // eslint-disable-line
  // BLOCKY_BANKA_V3 (kritik S4): Sedí a zrušenie označenia vždy s otázkou (ústava 12.0 bod 3)
  const oznacSedi = async (r) => { if (!window.confirm('Označiť bloček ' + (r.dodavatel || '') + ' (' + eurS(r.suma) + ') ako Sedí?')) return; if (await zapis(r.id, { stav: 'sedi' })) toast.success('Bloček sedí') }
  const zrusOznacenie = async (r) => { if (!window.confirm('Zrušiť označenie bločku ' + (r.dodavatel || '') + ' (' + eurS(r.suma) + ')? Bloček bude znova na kontrolu.')) return; if (await zapis(r.id, { stav: '' })) toast.success('Označenie zrušené — bloček je znova na kontrolu') }
  const ulozNesedi = async () => {
    if (!edit) return
    if (!edit.pozn.trim()) { toast.error('Napíš, čo nesedí — podľa toho sa Matrix učí.'); return }
    const opravy = Object.entries(edit.opravy).filter(([, u]) => String(u || '').trim()).map(([riadok, ucet]) => ({ riadok, ucet: String(ucet).trim() }))
    if (await zapis(edit.id, { stav: 'nesedi', pozn: edit.pozn.trim(), opravy })) {   // BLOCKY_MOCKUP_V2: pomer sa neposiela — je z MKsoftu
      setEdit(null); toast.success('Uložené — nesedí' + (opravy.length ? ', oprava sa zapamätá' : ''))
      if (opravy.length && data) load(data.mesiac)   // ostatné bločky hneď ukážu návrh z opravy (15.4)
    }
  }

  if (!authorized) return <EmptyPane text="Kontrolu bločkov robí Štefánia." icon="" />
  if (!unlocked) return <EmptyPane icon="" text="Na zaúčtovanie je chránené PIN zámkom — klikni na záložku znova pre odomknutie." />

  const faza1 = !data || data.faza !== '2'
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md, flexWrap: 'wrap', background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '10px 14px' }}>
        <h1 style={{ fontSize: TYPO.sizes.lg, margin: 0, fontWeight: TYPO.weights.bold, color: COLORS.text, whiteSpace: 'nowrap' }}>Bločky — kontrola</h1>
        <select value={(data && data.mesiac) || ''} onChange={e => { const m = e.target.value; strazKlik(() => { setEdit(null); load(m) })() }} title="Mesiac podľa dátumu bločku"
          style={{ border: `1px solid ${COLORS.line}`, background: COLORS.bg, borderRadius: RADIUS.full, padding: '5px 10px', fontFamily: 'inherit', fontSize: TYPO.sizes.base, color: COLORS.text, cursor: 'pointer' }}>
          {((data && data.mesiace) || []).map(m => <option key={m.mesiac} value={m.mesiac}>{m.nazov}</option>)}
        </select>
        {FILTRE.map(f => (
          <Chip key={f.key} on={filter === f.key} onClick={() => setFilter(f.key)}>
            {f.label}
            <b style={{ marginLeft: 4 }}>
              {f.key === 'vsetky' ? `${pocty.vsetky} · ${eurS(pocty.suma)}` : f.key === 'sedi' ? `${pocty.sedi} z ${pocty.skontrolovane}` : f.key === 'banka' ? pocetBanka : pocty[f.key]}
            </b>
            {f.nove && <span style={{ fontSize: 10.5, fontWeight: TYPO.weights.bold, color: '#fff', background: COLORS.nav, borderRadius: 4, padding: '1px 5px', marginLeft: 6, verticalAlign: 'middle' }}>NOVÉ</span>}
          </Chip>
        ))}
        <span style={{ flex: 1 }} />
        {faza1 && <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.warn, background: COLORS.totalBg, borderRadius: RADIUS.md, padding: '4px 8px', whiteSpace: 'nowrap' }}>Kontrola bločkov · do MKsoft KAMIR sa posiela z časti Bločky (od 1. 11. 2026)</span>}
        {data && data.archiv_pocet > 0 && <span style={malo}>{data.archiv_pocet === 1 ? '1 starý bloček je' : data.archiv_pocet <= 4 ? data.archiv_pocet + ' staré bločky sú' : data.archiv_pocet + ' starých bločkov je'} v archíve — len na prezeranie v časti Bločky</span>}   {/* BLOCKY_BANKA_V3 (čitatelia č. 3) */}
        <HelpHint section="86.13" text={NAPOVEDA} />
      </div>

      <div style={{ flex: 1, overflow: 'auto', paddingBottom: SPACE.lg }}>
        {!data ? (
          <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.md }}>Načítavam bločky…</div>
        ) : data.caka_mksoft ? (
          <div style={{ marginTop: SPACE.md, padding: SPACE.lg, color: COLORS.text, fontSize: TYPO.sizes.md, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg }}>
            <b>Čakám na údaje z MKsoftu</b> — rozvrh účtov a predkontácie firmy KAMIR (len čítanie). Bez nich Matrix bločky nerozpočíta (ústava 110.14).
            <div style={malo}>{data.mksoft_stav && data.mksoft_stav.chyba ? 'Posledný pokus: ' + data.mksoft_stav.chyba + '. ' : ''}Skúšam znova každých 15 s.</div>
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ marginTop: SPACE.md, padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.md, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg }}>
            {rows.length === 0 ? `V mesiaci ${data.mesiac_nazov} nie sú žiadne bločky. Konatelia ich skenujú v telefóne v Bločkoch.` : 'V tomto filtri nie je žiadny bloček.'}
          </div>
        ) : filtered.map(r => (
          <KartaBlocku key={r.id} r={r} busy={busy} spracuje={!!(data && data.spracuje) && !r.odoslane} ucetOptions={ucetOptions} katOptions={katOptions} katPreBlocok={data.kategorie_blocok} nedanoveUcty={data.nedanove_ucty} onKategoria={(p, k) => zmenKategoriu(r, p, k)} onPotvrdKat={() => potvrdKategorie(r)}
            vypis={vypis.mesiac === data.mesiac ? vypis.rows : []} onBanka={(body) => banka(r, body)}
            edit={edit && edit.id === r.id ? edit : null}
            onSedi={() => oznacSedi(r)} onZrus={() => zrusOznacenie(r)}
            onNesedi={strazKlik(() => setEdit({ id: r.id, pozn: '', opravy: {} }))}
            onEdit={(patch) => setEdit(e => (e && e.id === r.id ? { ...e, ...patch, opravy: { ...e.opravy, ...(patch.opravy || {}) } } : e))}
            onUloz={ulozNesedi} onZrusEdit={() => setEdit(null)} />
        ))}
      </div>
    </div>
  )
}

const GRID = '92px minmax(0,1.6fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1.1fr) 110px minmax(0,1.3fr)'
// blocky_vzhlad_v1 (24. 10. 2026): tmavšia hlavička tabuľky, peniaze ako skupina (zvislá čiara), Spolu oddelené, pevné šírky čísel
const th = { padding: '7px 10px', borderBottom: `1px solid ${COLORS.line}`, textAlign: 'left', fontSize: TYPO.sizes.xs, color: COLORS.text, textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: TYPO.weights.bold, background: '#EEF1F5', verticalAlign: 'bottom' }
const td = { padding: '6px 10px', borderBottom: `1px solid ${COLORS.lineSoft}`, textAlign: 'left', fontSize: TYPO.sizes.md, verticalAlign: 'top', color: COLORS.text }
const tdN = { ...td, textAlign: 'right', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }
const thN = { ...th, textAlign: 'right', width: 104 }
const SKUPINA = { borderLeft: `1px solid ${COLORS.line}` }            // začiatok peňazí
const SPOLU_STL = { borderLeft: `1px solid ${COLORS.line}`, background: COLORS.bgSoft, fontWeight: TYPO.weights.bold }
const STAV_FARBA = { na_kontrolu: COLORS.warn, sedi: COLORS.add, nesedi: COLORS.remove }

// BLOCKY_MOCKUP_V2 (Mirko 24. 10. 2026, mockup MOCKUP_Blocky_parovanie_skutocne_2026-10-24.html, Kronika mksoft 3277/3283/3292): každá položka z eKasy
// vlastný riadok, kategória sa mení pri položke, účet z osnovy MKsoftu, pomer nákladu a DPH len zobrazený (z predkontácie MKsoftu, ústava 110.14),
// párovanie s výpisom VÚB / Pokladňou, náhľad dokladu do cvičnej MATRIX s.r.o.
// BLOCKY_MOCKUP_V5: riadok s navrhnutou (nepotvrdenou) kategóriou je vyfarbený (COLORS.totalBg) a Sedí nejde, kým ju back office nepotvrdí
const thG = { ...th, textAlign: 'center', background: '#F3F5F8', borderBottom: `1px solid ${COLORS.line}`, paddingTop: 5, paddingBottom: 5 }
const PAIR = { display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', padding: '9px 14px', borderTop: `1px dashed ${COLORS.line}`, background: '#FCFDFF', fontSize: TYPO.sizes.md }
const PAIR_LBL = { fontWeight: TYPO.weights.bold, minWidth: 70 }
const CAND = { border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '4px 9px', background: COLORS.bg }
const selStl = { border: `1px solid ${COLORS.line}`, background: COLORS.bg, borderRadius: RADIUS.lg, padding: '4px 8px', fontFamily: 'inherit', fontSize: TYPO.sizes.sm, color: COLORS.text, maxWidth: 360 }
const vypisText = (x) => 'VÚB ' + datumSk(x.datum) + ' · −' + eurS(x.suma) + (x.popis ? ' · „' + x.popis + '“' : '')

function KartaBlocku({ r, busy, spracuje, ucetOptions, katOptions, katPreBlocok, nedanoveUcty, vypis, onKategoria, onPotvrdKat, onBanka, edit, onSedi, onZrus, onNesedi, onEdit, onUloz, onZrusEdit }) {
  const opravene = r.riadky.filter(l => l.ucet_zdroj === 'oprava')
  // BLOCKY_MOCKUP_V6 č. 3, 9: kategórie len s predkontáciou pre platbu bločku; účty len v rovnakom syntetickom účte (nedaňová časť len nedaňové)
  const katMoznosti = useMemo(() => {
    if (!Array.isArray(katPreBlocok)) return katOptions
    const ok = new Set(katPreBlocok.filter(k => (r.platba === 'hotovosť' ? k.hotovost : r.platba === 'karta' ? k.karta : (k.karta || k.hotovost))).map(k => k.kategoria))
    return katOptions.filter(o => ok.has(o.value))
  }, [katPreBlocok, katOptions, r.platba])
  const uctyPreRiadok = (l) => {
    const pred = String(l.ucet_bez_opravy || l.ucet || '').slice(0, 3)
    const ned = new Set(nedanoveUcty || [])
    return ucetOptions.filter(o => (!pred || String(o.value).slice(0, 3) === pred) && (l.typ === 'nedan' ? ned.has(String(o.value)) : !ned.has(String(o.value))))
  }
  const menitKat = spracuje && !r.exportovane
  return (
    <div style={{ background: COLORS.bg, border: '1px solid #CBD5E1', borderLeft: `4px solid ${STAV_FARBA[r.stav] || '#CBD5E1'}`, borderRadius: RADIUS.lg, marginTop: 18, overflow: 'hidden', boxShadow: '0 1px 3px rgba(15,23,42,0.08)' }}>   {/* blocky_vzhlad_v1: bloček oddelený od bločku */}
      <div style={{ display: 'grid', gridTemplateColumns: GRID, gap: 10, alignItems: 'start', padding: '10px 14px', borderBottom: `1px solid ${COLORS.line}`, fontSize: TYPO.sizes.md, color: COLORS.text, background: COLORS.bgSoft }}>
        <div><b>{datumSk(r.datum)}</b>{r.cas && <div style={malo}>{r.cas}</div>}</div>
        <div style={{ minWidth: 0 }}>
          <b>{r.dodavatel || '—'}</b>
          <div style={malo}>{[r.ico ? 'IČO ' + r.ico : '', r.okp ? 'OKP ' + r.okp : '', r.skenoval ? 'naskenoval ' + r.skenoval : ''].filter(Boolean).join(' · ') || '—'}</div>
        </div>
        <div>{r.platba || '—'}{r.platba_popis && <div style={malo}>{r.platba_popis}</div>}</div>
        <div title={r.doklad.dal_nazov ? 'D ' + r.doklad.dal + ' ' + r.doklad.dal_nazov + (r.doklad.kod_popis ? ' · ' + r.doklad.kod_popis : '') : ''}>
          {r.doklad.typ ? <span style={TAG.modra}>{r.doklad.typ} {r.doklad.nazov}</span> : <span style={chyba}>typ dokladu ?</span>}
          <div style={malo}>
            {r.doklad.dal ? 'D ' + r.doklad.dal : <span style={chyba}>D ? chýba kód predkontácie</span>}
            {r.doklad.kod ? ' · kód ' + r.doklad.kod : ''}
          </div>
        </div>
        <div>{r.stredisko}<div style={malo}>{r.zakazka ? [r.zakazka.id, r.zakazka.nazov].filter(Boolean).join(' ') + (r.zakazka.mksoft ? ' · MKsoft ' + r.zakazka.mksoft : '') : (r.vozidlo ? 'auto ' + r.vozidlo : '')}</div></div>
        <div style={{ textAlign: 'right', fontWeight: TYPO.weights.bold, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{eurS(r.suma)}</div>
        <div>
          <span style={TAG[r.stav]}>{STAV_TEXT[r.stav]}</span>
          {r.stav !== 'na_kontrolu' && <span style={{ ...malo, marginLeft: 6 }}>{r.kontroloval} {datumSk(r.kontrola_at)}</span>}
          {r.exportovane && <div style={malo}>exportované {datumSk(r.exportovane)}</div>}
        </div>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr><th style={{ ...th, background: '#F3F5F8', paddingTop: 5, paddingBottom: 5 }} colSpan={4} /><th style={{ ...thG, ...SKUPINA }} colSpan={2}>Základ</th><th style={{ ...thG, ...SKUPINA }} colSpan={2}>DPH</th><th style={{ ...thG, ...SKUPINA }} /></tr>
            <tr>
              <th style={th}>Položky z bločku (eKasa)</th><th style={th}>Predkontácia</th>
              <th style={{ ...th, width: 150 }}>Účet MD <span style={{ ...malo, textTransform: 'none', fontWeight: TYPO.weights.normal }}>(z osnovy MKsoftu)</span></th>
              <th style={{ ...thN, width: 130 }}>Náklad / DPH %</th>
              <th style={{ ...thN, ...SKUPINA }}>daňový</th><th style={thN}>nedaňový</th><th style={{ ...thN, ...SKUPINA }}>odpočet</th><th style={thN}>neuplatnená</th><th style={{ ...thN, ...SPOLU_STL, background: '#E2E8F0' }}>Spolu</th>
            </tr>
          </thead>
          <tbody>
            {r.riadky.map((l, ix) => (
              <tr key={l.riadok} style={{ background: l.kat_navrh ? COLORS.totalBg : (ix % 2 ? '#FBFCFD' : COLORS.bg) }}>
                <td style={td}>{l.nazov} {l.sadzba_text && <span style={malo}>({l.sadzba_text})</span>}</td>
                <td style={{ ...td, minWidth: menitKat && l.item_id ? 220 : 0 }} title={l.kod ? 'Predkontácia MKsoftu kód ' + l.kod + (l.mk_popis ? ' · ' + l.mk_popis : '') : ''}>
                  {menitKat && l.item_id ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <SearchableSelect menuPortal value={l.kategoria_polozky || l.kategoria || ''} options={katMoznosti} emptyLabel="— kategória —" placeholder="kategória položky…"
                          onChange={v => onKategoria({ id: l.item_id, nazov: l.nazov.replace(/ — (ne)?daňová časť$/, '') }, v || '')} />
                      </div>
                      {l.kat_navrh && <span style={TAG.na_kontrolu} title={l.kat_zdroj === 'pamat' ? 'Kategóriu navrhol Matrix podľa predošlej opravy tejto položky u predajcu — potvrď ju' : 'Kategóriu navrhol Matrix podľa bločku — potvrď ju alebo vyber inú'}>{l.kat_zdroj === 'pamat' ? 'návrh z minula' : 'návrh'}</span>}
                    </div>
                  ) : (l.kategoria || <span style={chyba}>bez kategórie</span>)}
                </td>
                <td style={{ ...td, minWidth: edit ? 170 : 0 }}>
                  {edit ? (
                    <SearchableSelect menuPortal value={edit.opravy[l.riadok] != null ? edit.opravy[l.riadok] : l.ucet} options={uctyPreRiadok(l)}
                      emptyLabel="vyber z osnovy MKsoftu" placeholder="hľadaj účet MKsoftu…" onChange={v => onEdit({ opravy: { [l.riadok]: v } })} />
                  ) : l.ucet_zdroj === 'oprava' && l.stary_ucet && l.stary_ucet !== l.ucet ? (
                    <span><s style={{ color: COLORS.muted }}>{l.stary_ucet}</s> → <b>{l.ucet}</b></span>
                  ) : l.bez_predkontacie ? <span style={chyba}>chýba predkontácia</span> : l.ucet ? (
                    <span>{l.ucet}</span>
                  ) : <span style={chyba}>vyber z osnovy MKsoftu</span>}
                  {l.navrh_ucet && <div style={{ ...malo, color: COLORS.nav }} title="Návrh z predošlej opravy tejto položky u toho istého predajcu — nedosadí sa sám (BLOCKY_MOCKUP_V4 č. 15)">návrh z opravy: {l.navrh_ucet}</div>}
                  {l.ucet_dph && l.ucet_dph !== l.ucet && <div style={malo}>DPH {l.ucet_dph}</div>}
                </td>
                <td style={tdN} title="Pomer nákladu a DPH sa číta z predkontácie a rozvrhu účtov MKsoftu — v Matrixe sa nemení (ústava 110.14). Zmeniť sa dá kategória položky.">
                  {l.pct_text}
                </td>
                <td style={{ ...tdN, ...SKUPINA }}>{eur(l.zaklad_dan)}</td><td style={tdN}>{eur(l.zaklad_nedan)}</td>
                <td style={{ ...tdN, ...SKUPINA }}>{eur(l.dph_odpocet)}</td><td style={tdN}>{eur(l.dph_neupl)}</td>
                <td style={{ ...tdN, ...SPOLU_STL }}>{eur(l.spolu)}</td>
              </tr>
            ))}
            <tr>
              <td style={{ ...td, fontWeight: TYPO.weights.bold, borderBottom: 0, borderTop: `2px solid ${COLORS.line}` }} colSpan={4}>
                Spolu bloček · <span style={r.rozdiel !== 0 ? chyba : {}}>{r.rozdiel_text || (r.rozdiel !== 0 ? 'rozdiel ' + eurS(r.rozdiel) + ' proti bločku' : 'sedí s bločkom')}</span>
              </td>
              {['zaklad_dan', 'zaklad_nedan', 'dph_odpocet', 'dph_neupl', 'spolu'].map((k, ix) => <td key={k} style={{ ...tdN, fontWeight: TYPO.weights.bold, borderBottom: 0, borderTop: `2px solid ${COLORS.line}`, ...(ix === 0 || ix === 2 ? SKUPINA : {}), ...(k === 'spolu' ? SPOLU_STL : {}) }}>{eur(r.spolu[k])}</td>)}
            </tr>
          </tbody>
        </table>
      </div>

      {!r.uplny && r.dovody && r.dovody.length > 0 && (   // BLOCKY_MOCKUP_V4 č. 18: prečo bloček nie je úplný (Sedí a zápis nejdú)
        <div style={{ padding: '7px 14px', borderTop: `1px solid ${COLORS.lineSoft}`, background: TINT.remove, fontSize: TYPO.sizes.sm, color: COLORS.remove }}>
          <b>Doklad nie je úplný</b> — Sedí ani zápis nejdú: {r.dovody.join(' · ')}
          {spracuje && r.riadky.some(l => l.kat_navrh) && (
            <BtnGhost onClick={onPotvrdKat} disabled={busy} style={{ marginLeft: 10, padding: '3px 10px', fontSize: TYPO.sizes.sm }}
              title="Uloží navrhnuté kategórie položiek ako potvrdené a zapamätá ich pre tohto predajcu">Potvrdiť kategórie ({new Set(r.riadky.filter(l => l.kat_navrh).map(l => l.item_id)).size})</BtnGhost>
          )}
        </div>
      )}
      {r.banka && <BankaRiadok r={r} vypis={vypis} spracuje={false} busy={busy} onBanka={onBanka} />}   {/* BLOCKY_BANKA_V3: párovanie s výpisom len v časti Bločky (s otázkou) */}
      {r.pokladna && (
        <div style={PAIR}>
          <span style={PAIR_LBL}>Pokladňa</span>
          <span style={{ color: COLORS.muted }}>hotovosť konateľa — páruje sa s výdajom v Pokladni alebo zálohou konateľa (nie s bankou)</span>
          <select style={selStl} defaultValue="" title="Výdaje v Pokladni s rovnakou sumou ±3 dni — len na pozretie; Pokladňu zapisuje len office">
            <option value="">{r.pokladna.kandidati.length ? 'Vybrať výdaj v Pokladni ▾ (' + r.pokladna.kandidati.length + ')' : 'V Pokladni nie je výdaj ' + eurS(r.suma) + ' (±3 dni)'}</option>
            {r.pokladna.kandidati.map(k => <option key={k.id} value={k.id}>{datumSk(k.datum)} · {eurS(k.suma)} · {k.popis}</option>)}
          </select>
        </div>
      )}
      {r.nahlad && <NahladDokladu n={r.nahlad} doklad={r.doklad} />}

      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', padding: '10px 14px', background: COLORS.bgSoft, borderTop: `1px solid ${COLORS.line}` }}>
        {r.odoslane ? (   /* BLOCKY_BANKA_V3 (čitatelia N2): odoslaný do MKsoftu = len na prezeranie */
          <>
            <MksoftPorovnanie m={r.mksoft} />
            <span style={{ flex: 1 }} />
            <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>Odoslané do MKsoft KAMIR — len na prezeranie</span>
          </>
        ) : edit ? (
          <>
            <input value={edit.pozn} onChange={e => onEdit({ pozn: e.target.value })} autoFocus maxLength={500}
              placeholder="Čo nesedí — napr. obed je reprezentácia, zmenila som kategóriu"
              style={{ flex: '1 1 420px', minWidth: 240, fontFamily: 'inherit', fontSize: TYPO.sizes.md, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: '6px 8px' }} />
            <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.nav }}>Opravený účet sa zapamätá pre ďalšie bločky tohto dodávateľa a kategórie (ústava 15.4). Pomer nákladu a DPH je z MKsoftu.</span>
            <span style={{ flex: 1 }} />
            <BtnGhost onClick={onZrusEdit} disabled={busy}>Zrušiť</BtnGhost>
            <BtnAdd onClick={onUloz} disabled={busy}>Uložiť — nesedí</BtnAdd>
          </>
        ) : r.stav === 'na_kontrolu' ? (
          <>
            <MksoftPorovnanie m={r.mksoft} />
            <span style={{ flex: 1 }} />
            {spracuje ? (<>
            <BtnAdd onClick={onSedi} disabled={busy || !r.uplny} title={r.uplny ? '' : 'Doklad nie je úplný: ' + (r.dovody || []).join('; ')}>Sedí</BtnAdd>
            <BtnGhost onClick={onNesedi} disabled={busy} style={{ color: COLORS.remove, borderColor: COLORS.remove }}>Nesedí — opraviť</BtnGhost>
            </>) : <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>Kontroluje Štefánia (ústava 135.2).</span>}
          </>
        ) : r.stav === 'nesedi' ? (
          <>
            <MksoftPorovnanie m={r.mksoft} />
            <span style={{ flex: '1 1 420px', fontSize: TYPO.sizes.md, color: COLORS.text }}>{r.kontroloval ? r.kontroloval + ': ' : ''}{r.pozn}</span>
            {opravene.length > 0 && <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.nav }}>Oprava sa zapamätá: ďalšie bločky {r.dodavatel} navrhnú {opravene.map(l => (l.kategoria ? l.kategoria + ' → ' : '') + l.ucet).join(', ')} (ústava 15.4).</span>}
            {spracuje && <BtnGhost onClick={onZrus} disabled={busy} title="Vráti bloček na kontrolu">Zmeniť</BtnGhost>}
          </>
        ) : (
          <>
            <MksoftPorovnanie m={r.mksoft} />
            <span style={{ flex: 1 }} />
            {spracuje && <BtnGhost onClick={onZrus} disabled={busy} title="Vráti bloček na kontrolu">Zrušiť označenie</BtnGhost>}
          </>
        )}
      </div>
    </div>
  )
}

// párovanie kartového bločku s riadkom výpisu VÚB (bank_transactions; Saldo bločky nepáruje)
function BankaRiadok({ r, vypis, spracuje, busy, onBanka }) {
  const b = r.banka
  const ine = (vypis || []).filter(x => !b.tx || x.id !== b.tx.id)
  const vyberIny = (e) => {
    const id = e.target.value; e.target.value = ''
    if (!id) return
    const x = (vypis || []).find(v => String(v.id) === String(id))
    const dni = x ? Math.round((new Date(x.datum + 'T00:00:00Z') - new Date(r.datum + 'T00:00:00Z')) / 86400000) : 0
    const inaSuma = x && Math.abs(x.suma - r.suma) > 0.005, inyDatum = x && !(dni >= -3 && dni <= 10)   // BLOCKY_MOCKUP_V5: dátum −3 až +10 dní
    if (inaSuma || inyDatum) {   // BLOCKY_MOCKUP_V4 č. 26: iná suma / iný dátum = potvrdenie a poznámka
      const pozn = window.prompt((inaSuma ? 'Suma na výpise ' + eurS(x.suma) + ' sa líši od bločku ' + eurS(r.suma) + '. ' : '') + (inyDatum ? 'Platba je ' + (dni > 0 ? '+' : '') + dni + ' dní od bločku. ' : '') + 'Napíš slovami, prečo to k sebe patrí (aspoň 10 znakov):', '')
      if (!pozn || pozn.trim().length < 10) return
      onBanka({ tx_id: x.id, ina_suma: !!inaSuma, iny_datum: !!inyDatum, pozn: pozn.trim() }); return
    }
    onBanka({ tx_id: Number(id) || id })
  }
  return (
    <div style={PAIR}>
      <span style={PAIR_LBL}>Banka</span>
      {b.stav === 'sparovane' ? (
        <>
          <span style={CAND}>{vypisText(b.tx)}</span>
          <span style={TAG.sedi}>spárované</span>
          <span style={malo}>{b.kto} {datumSk(b.kedy)}</span>
          {spracuje && <BtnGhost onClick={() => onBanka({ zrusit: true })} disabled={busy} style={{ padding: '4px 10px', fontSize: TYPO.sizes.sm }}>Zrušiť párovanie</BtnGhost>}
        </>
      ) : b.stav === 'navrh' ? (
        <>
          <span style={CAND}>{vypisText(b.tx)}</span>
          <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.add }}>✓ {(b.dovod || []).join(', ')}</span>
          {spracuje && <button type="button" onClick={() => onBanka({ tx_id: b.tx.id })} disabled={busy}
            style={{ fontFamily: 'inherit', fontSize: TYPO.sizes.sm, borderRadius: RADIUS.lg, padding: '4px 10px', border: `1px solid ${COLORS.nav}`, background: COLORS.nav, color: '#fff', cursor: 'pointer' }}>Potvrdiť párovanie</button>}
        </>
      ) : (
        <span style={{ color: COLORS.muted }}>Vo výpise VÚB za tento mesiac nie je riadok −{eurS(r.suma)}.</span>
      )}
      {b.stav !== 'sparovane' && <span style={malo}>· spáruješ v časti Bločky</span>}
      {spracuje && b.stav !== 'sparovane' && (
        <select style={selStl} defaultValue="" onChange={vyberIny} disabled={busy} title="Celý výpis VÚB (platby z účtu) v mesiaci bločku">
          <option value="">{b.stav === 'navrh' ? 'Iný riadok výpisu ▾' : 'Hľadať vo výpise ▾'}</option>
          {ine.map(x => <option key={x.id} value={x.id}>{datumSk(x.datum)} · −{eurS(x.suma)} · {x.popis}</option>)}
        </select>
      )}
    </div>
  )
}

// náhľad dokladu, ktorý pôjde do cvičnej MATRIX s.r.o. — tlačidlo sa zapne po overenom recepte zápisu (skúšobné zápisy), nikdy do KAMIR
function NahladDokladu({ n, doklad }) {
  return (
    <div style={{ padding: '9px 14px', borderTop: `1px dashed ${COLORS.line}`, background: COLORS.bg }}>
      <div style={{ fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold, marginBottom: 4 }}>
        Zápis do {n.firma} — náhľad dokladu {n.typ} {doklad && doklad.nazov ? '(' + doklad.nazov + ')' : ''}
      </div>
      <table style={{ width: 'auto', minWidth: 520, borderCollapse: 'collapse' }}>
        <thead><tr><th style={th}>MD</th><th style={th}>D</th><th style={thN}>Suma €</th><th style={th}>Popis</th></tr></thead>
        <tbody>
          {n.riadky.map((x, i) => (
            <tr key={i}>
              <td style={td}>{x.md === '?' ? <span style={chyba}>?</span> : x.md}</td>
              <td style={td}>{x.d === '?' ? <span style={chyba}>?</span> : x.d}</td>
              <td style={tdN}>{eur(x.suma)}</td>
              <td style={td}>{x.md === '?' ? <span style={chyba}>doplní Štefánia</span> : x.popis}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginTop: 6 }}>
        <span style={malo}>Dátum {datumSk(n.datum)} {String(n.datum || '').slice(0, 4)} · text „{n.text}“ · kód {n.kod || '?'} · do MKsoft KAMIR sa posiela z časti Bločky</span>
      </div>
    </div>
  )
}

// BLOCKY_POROVNANIE_V1 — doklad v denníku MKsoftu k bločku (časť 4 návrhu, Kronika mksoft 3041/3254)
function MksoftPorovnanie({ m }) {   // BLOCKY_MOCKUP_V1: „V MKsofte: I 419 z 21. 10. · 84,50 € · 501100 / 343 · zhoda“ ako v mockupe
  if (!m) return <span style={{ fontSize: TYPO.sizes.md, color: COLORS.text }}><b>V MKsofte (KAMIR, len čítanie):</b> <span style={{ color: COLORS.muted }}>zatiaľ nenačítané — dopĺňa sa samo</span></span>   // BLOCKY_MOCKUP_V2
  const d = m.doklad
  const stitok = m.stav === 'zhoda' ? TAG.sedi : m.stav === 'nenajdene' ? TAG.nesedi : TAG.na_kontrolu
  const text = m.stav === 'zhoda' ? 'zhoda' : m.stav === 'nenajdene' ? 'v MKsofte zatiaľ nie je' : 'riadky porovnať'
  const ucty = d ? [...(d.md || []), ...((d.riadky || []).some(x => /^343/.test(x.md || '')) ? ['343'] : [])].join(' / ') : ''
  return (
    <span style={{ fontSize: TYPO.sizes.md, color: COLORS.text }} title={d ? 'MD v MKsofte ' + ((d.md || []).join(', ') || '—') + ' · v Matrixe ' + ((m.ucty_matrix || []).join(', ') || '—') + (m.kandidatov > 1 ? ' · ' + m.kandidatov + ' doklady s rovnakou sumou' : '') + (d.text ? ' · ' + d.text : '') : 'doklad P alebo I s touto sumou v denníku MKsoftu (mesiac bločku a 15 dní po ňom)'}>
      <b>V MKsofte (KAMIR, len čítanie):</b>{d ? ' ' + d.typ + ' ' + String(d.cislo || '').replace(/^[A-Z]+\s*/, '') + ' z ' + datumSk(d.datum) + ' · ' + eurS(d.suma) + (ucty ? ' · ' + ucty : '') + ' · ' : ' '}
      <span style={stitok}>{text}</span>
    </span>
  )
}
